<app-common-header-layout
  class="common-header-layout"
  [trackingObject]="trackingObject$ | async"
  [trackingScreenName]="trackingScreenName"
>
  <div class="content">
    <ng-container *ngIf="resultIcon$ | async as resultIcon; else placeholder">
      <i2g-icon class="result-icon" [icon]="resultIcon"> </i2g-icon>

      <h1 class="title">
        {{ title$ | async }}
      </h1>

      <h2 class="sub-title">
        {{ subtitle$ | async }}
      </h2>
    </ng-container>

    <ng-template #placeholder>
      <div class="icon-placeholder shimmer"></div>

      <div class="title-placeholder shimmer"></div>

      <div class="sub-title-placeholder shimmer"></div>
    </ng-template>
  </div>
</app-common-header-layout>
